export const useSouthpoleStore = defineStore('southpole', () => {
  // state
  const accessToken = ref('')

  // actions
  function setAccessToken(token: string) {
    accessToken.value = token
  }

  return { accessToken, setAccessToken }
})
